import {XauditModel} from '../../../../../models/xaudit.model';

export class EndoDiagnosisToothDetailScDataModel extends XauditModel {
  EndoDiagToothDetailSCID: string;
  EndoDiagToothDetailID: string;
  enumDiagSurfaceORCanalD: string;
  enumToothSurfaceID: string;
  enumToothCanalID: string;
  isSelected: boolean;
}
